// Pure frontend Email System - 100% Free of Cost, Zero Backend Required

const EMAILJS_API_URL = "https://api.emailjs.com/api/v1.0/email/send";
const FORMSUBMIT_ENDPOINT = "https://formsubmit.co/ajax/uttam@vardhamangroup.info";

export const EMAILJS_CONFIG = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "",
  templateAdmin: process.env.REACT_APP_EMAILJS_TEMPLATE_ADMIN || "",
  templateClient: process.env.REACT_APP_EMAILJS_TEMPLATE_CLIENT || "",
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "",
};

/**
 * Emergent Free Email System (FormSubmit)
 * - 100% Free of cost forever
 * - Zero API keys, zero backend servers
 * - Sends inquiry directly to uttam@vardhamangroup.info
 * - CCs amol@vardhamaanconsultancyservices.com
 * - Automatically sends formatted auto-response to the candidate / form filler
 */
export async function sendEmergentFreeMail(inquiryData) {
  const name = inquiryData.name || "Client";
  const service = inquiryData.service || "Workforce Solutions";
  const message = inquiryData.message || "No message provided";

  const autoResponseText = 
    `Dear ${name},\n\n` +
    `Thank you for contacting Vardhamaan Consultancy Services.\n\n` +
    `We have successfully received your requirement regarding: ${service}.\n` +
    `Our talent advisory and mobilization team will review your specifications and contact you within 24 business hours.\n\n` +
    `Submitted Details:\n` +
    `- Name: ${name}\n` +
    `- Service: ${service}\n` +
    `- Message: "${message}"\n\n` +
    `Direct Office Contacts:\n` +
    `Head Office (Mumbai): +91 84464 97833\n` +
    `Email: amol@vardhamaanconsultancyservices.com / uttam@vardhamangroup.info\n` +
    `Website: https://vardhamaanconsultancyservices.com\n\n` +
    `Best regards,\n` +
    `Vardhamaan Consultancy Services\n` +
    `(ISO 9001:2015 Certified | Ministry of External Affairs Licensed)`;

  const payload = {
    "Name": name,
    "Company": inquiryData.company || "N/A",
    "Email": inquiryData.email,
    "Phone": inquiryData.phone || "N/A",
    "Service Required": service,
    "Requirement Details": message,
    "_subject": `[New Website Inquiry] ${name} - ${service}`,
    "_cc": "amol@vardhamaanconsultancyservices.com",
    "_replyto": inquiryData.email,
    "_template": "table",
    "_captcha": "false",
    "_autoresponse": autoResponseText,
  };

  try {
    const response = await fetch(FORMSUBMIT_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json().catch(() => ({}));
    return response.ok || result.success === "true" || result.success === true;
  } catch (error) {
    console.warn("Emergent free mail error:", error);
    return false;
  }
}

/**
 * Dispatches inquiry emails from frontend:
 * 1. Tries EmailJS if configured.
 * 2. Defaults to Emergent Free Mail (FormSubmit) - sends to uttam & amol + auto-reply to user!
 */
export async function dispatchFrontendInquiryEmails(inquiryData) {
  // If EmailJS keys are provided, use EmailJS
  if (EMAILJS_CONFIG.publicKey && EMAILJS_CONFIG.serviceId) {
    try {
      const baseParams = {
        name: inquiryData.name || "Client",
        company: inquiryData.company || "Not specified",
        email: inquiryData.email || "",
        phone: inquiryData.phone || "Not specified",
        service: inquiryData.service || "General Inquiry",
        message: inquiryData.message || "",
        admin_emails: "uttam@vardhamangroup.info, amol@vardhamaanconsultancyservices.com",
        submission_time: new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
        ref_id: "REF-" + Math.random().toString(36).substring(2, 8).toUpperCase(),
      };

      const adminPromise = fetch(EMAILJS_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          service_id: EMAILJS_CONFIG.serviceId,
          template_id: EMAILJS_CONFIG.templateAdmin,
          user_id: EMAILJS_CONFIG.publicKey,
          template_params: {
            ...baseParams,
            to_email: "uttam@vardhamangroup.info, amol@vardhamaanconsultancyservices.com",
            reply_to: inquiryData.email,
          },
        }),
      });

      let clientPromise = Promise.resolve();
      if (inquiryData.email && inquiryData.email.includes("@")) {
        clientPromise = fetch(EMAILJS_API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            service_id: EMAILJS_CONFIG.serviceId,
            template_id: EMAILJS_CONFIG.templateClient,
            user_id: EMAILJS_CONFIG.publicKey,
            template_params: {
              ...baseParams,
              to_name: inquiryData.name,
              to_email: inquiryData.email,
            },
          }),
        });
      }

      const [adminRes] = await Promise.all([adminPromise, clientPromise]);
      if (adminRes.ok) return true;
    } catch (e) {
      console.warn("EmailJS attempt failed, falling back to emergent free mail:", e);
    }
  }

  // 100% Free Emergent Mail System
  return await sendEmergentFreeMail(inquiryData);
}
